import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles/index';
import { Button, Card, CardContent, FormControl, Input, InputLabel, Typography } from '@material-ui/core';
import classNames from 'classnames';
import * as Actions from 'auth/store/actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
//import { Link } from 'react-router-dom';
import _ from 'lodash';
import Utils from 'yeffect/utils';
import {API, populateRole} from "../../../config";

const users = API.service('users');

const styles = theme => ({
  root: {
    background: "url('/assets/images/backgrounds/city_street.png') no-repeat",
    backgroundSize: 'cover'
  },
  intro: {
    color: '#ffffff'
  },
  card: {
    width: '100%',
    maxWidth: 400
  }
});

class Login extends Component {
  state = {
    email: '',
    password: '',
    error: false,
    lat: '',
    lon: '',
    speed: '',
    heading: '',
  };

  componentWillMount() {
    this.submit = this.submit.bind(this);
  }

  handleChange = (event) => {
    this.setState(_.set({ ...this.state }, event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value));
  };

  canBeSubmitted() {
    const { email, password } = this.state;
    return (
      email.length > 0 && password.length > 0
    );
  }

  submit(e) {
    e.preventDefault();

    const { email, password } = this.state;

    var controller = this;

    controller.setState({
      error: false
    })

    API.authenticate({
      strategy: 'local',
      email: email,
      password: password
    }).then(response => {
      console.log(response);
      if (!Utils.isEmpty(response.message)) {
        //error
      } else {
        users.find({ query: { email: email } }).then((u) => {
          u = u.data[0];
          var payload = {
            data: {
              data: {
                'displayName': u.userFirstName + ' ' + u.userLastName,
                'photoURL': 'assets/images/avatars/profile.jpg',
                'email': u.email,
                'ident': u.id,
                'id_number': u.id_number,
                settings: {}
              },
              role: populateRole(u.permissions)
            }
          }

          controller.props.setUserData(payload.data);

          if (u.emailConfirmed) {
            var loc = (Utils.isEmpty(u.default_access)) ? '/dashboard' : u.default_access;

            controller.props.history.push({
              pathname: loc,
              state: { redirectUrl: controller.props.location.pathname }
            });

          } else {

            controller.props.history.push({
              pathname: '/register',
              search: '?confirmemail=1&email=' + u.email,
              state: { redirectUrl: controller.props.location.pathname }
            });

          }
        })
      }

    }).catch((error) => {
      controller.setState({
        error: true
      })
    })
  }

  render() {
    const { classes } = this.props;
    const { email, password } = this.state;

    return (
      <div className={classNames(classes.root, "flex flex-col flex-auto flex-no-shrink items-center justify-center p-32")}>

        <div className="flex flex-col items-center justify-center w-full">


          <Card className={classes.card}>

            <CardContent className="flex flex-col items-center justify-center p-32">

              <img className="m-16" style={{ width: '220px' }} src="assets/DCSX.png" alt="logo" />

              <Typography variant="title" className="mt-16 mb-16">LOGIN TO YOUR ACCOUNT</Typography>

              {(this.state.error) &&
                <div
                  className="sm:w-320 bg-red-lightest border border-red-light text-red-dark p-12 mb-12 rounded relative text-center"
                  role="alert">
                  <span className="block sm:inline">Username or Password is Incorrect</span>
                </div>
              }

              <form name="loginForm" noValidate className="flex flex-col justify-center w-full" method={'POST'} onSubmit={this.submit}>

                <FormControl className="mb-16" fullWidth required>
                  <InputLabel>Email</InputLabel>
                  <Input
                    type="email"
                    name="email"
                    value={email}
                    onChange={this.handleChange}
                  />
                </FormControl>

                <FormControl className="mb-16" fullWidth required>
                  <InputLabel>Password</InputLabel>
                  <Input
                    type="password"
                    name="password"
                    value={password}
                    onChange={this.handleChange}
                  />
                </FormControl>

                <div className="flex items-center justify-between">

                  {/*<Link className="font-medium" to="/forgotpassword">
                    Forgot Password?
                        </Link>*/}
                </div>

                <Button type="submit"
                  variant="raised"
                  color="primary"
                  className="w-full mx-auto mt-16 normal-case"
                  aria-label="LOG IN"
                  value="legacy"
                  disabled={!this.canBeSubmitted()}
                >
                  Login
                                </Button>

              </form>

            </CardContent>
          </Card>
        </div>
      </div>
    );
  }

}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    setUserData: Actions.setUserData
  }, dispatch);
}

function mapStateToProps({ fuse, auth }) {
  return {
    login: auth.login,
    user: auth.user
  }
}

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(Login));



// WEBPACK FOOTER //
// ./src/main/content/login/Login.js